const TRUSTBADGE_SELECTOR = '[id^="trustbadge-container"] ._1g5l15h';

function isTabletOrMobile() {
    return window.matchMedia("(max-width: 1023px)").matches;
}

function setTrustbadgeStickyBarVisiblePosition() {
    if (!isTabletOrMobile()) return;

    const trustBadge = document.querySelector(TRUSTBADGE_SELECTOR);
    const stickyAddToCart = document.querySelector('#sticky-add-to-cart');
    
    if (trustBadge && stickyAddToCart) {
        const stickyHeight = stickyAddToCart.offsetHeight + 10;

        trustBadge.style.setProperty('bottom', stickyHeight + 'px', 'important');
        trustBadge.style.setProperty('transition', 'bottom 0.3s ease', 'important');
    }
}

function setTrustbadgeInitialPosition() {
    if (!isTabletOrMobile()) return;

    const trustBadge = document.querySelector(TRUSTBADGE_SELECTOR);
    
    if (trustBadge) {
        trustBadge.style.setProperty('bottom', '10px', 'important');
    }
}

document.addEventListener('stickyAddToCart:visible', setTrustbadgeStickyBarVisiblePosition);
document.addEventListener('stickyAddToCart:hidden', setTrustbadgeInitialPosition);